/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_A3Inputs */

const en_viewer_faq_a3 = /** @type {(inputs: Viewer_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few megabytes is comfortable. The parser builds a node for every value with no streaming or virtualization, so memory use is several times the raw file size. Tens of megabytes will make the tab sluggish or exhaust its memory.`)
};

const ko_viewer_faq_a3 = /** @type {(inputs: Viewer_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`몇 메가바이트는 편안합니다. 파서가 스트리밍이나 가상화 없이 모든 값에 대해 노드를 만들므로 메모리 사용량이 원본 파일 크기의 몇 배가 됩니다. 수십 메가바이트가 되면 탭이 느려지거나 메모리가 고갈됩니다.`)
};

const ja_viewer_faq_a3 = /** @type {(inputs: Viewer_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数メガバイトは快適です。パーサはストリーミングも仮想化もせずすべての値にノードを作るので、メモリ使用量は元のファイルサイズの数倍になります。数十メガバイトになるとタブが重くなるかメモリを使い切ります。`)
};

/**
* | output |
* | --- |
* | "A few megabytes is comfortable. The parser builds a node for every value with no streaming or virtualization, so memory use is several times the raw file siz..." |
*
* @param {Viewer_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_a3 = /** @type {((inputs?: Viewer_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_a3(inputs)
	if (locale === "ko") return ko_viewer_faq_a3(inputs)
	return ja_viewer_faq_a3(inputs)
});